module.exports = __webpack_public_path__ + "media/src/assets/Images/RealEstateSearchIcon-3b60d1f3c06c5cb7152c177a7caa9663.svg";